var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('import-page',{attrs:{"title":"批量导入核注单","loading":_vm.loading,"templateUrl":_vm.templateUrl,"columns":_vm.columns,"isValid":_vm.isValid,"limit":1000,"previewList":_vm.previewList,"importLoading":_vm.importLoading},on:{"on-import":_vm.importList,"on-preview":_vm.previewFile}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }